const buttons = [
  {
    type: "evaluate",
    id: "equals",
    value: "=",
  },
  {
    type:"decimal",
    id: "decimal",
    value: ".",
  },
  {
    id: "zero",
    value: "0",
    type: "number",
  },
  {
    id: "one",
    value: "1",
    type: "number",
  },
  {
    id: "two",
    value: "2",
    type: "number",
  },
  {
    id: "three",
    value: "3",
    type: "number",
  },
  {
    id: "four",
    value: "4",
    type: "number",
  },
  {
    id: "five",
    value: "5",
    type: "number",
  },
  {
    id: "six",
    value: "6",
    type: "number",
  },
  {
    id: "seven",
    value: "7",
    type: "number",
  },
  {
    id: "eight",
    value: "8",
    type: "number",
  },
  {
    id: "nine",
    value: "9",
    type: "number",
  },
  {
    type: "operator",
    id: "add",
    value: "+",
  },
  {
    type: "operator",
    id: "subtract",
    value: "‑",
  },
  {
    type: "operator",
    id: "multiply",
    value: "x",
  },
  {
    type: "operator",
    id: "divide",
    value: "/",
  },
  {
    type: "clear",
    id: "clear",
    value: "AC",
  },
];

export { buttons };
